import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ErrorPage } from './ErrorPage';
export function NotFoundPage() {
    return (_jsx(ErrorPage, { title: _jsx(_Fragment, { children: "Check your broadcast\u00A0link" }), description: _jsx(_Fragment, { children: "Make sure that you've entered the correct broadcast\u00A0link in the URL." }) }));
}
